import gql from "graphql-tag";

export const CREATE_CRM_SEQUENCE_TEMPLATE = gql`
  mutation AddCrmSequenceTemplate($data: CrmSequenceTemplateDataInput) {
    addCrmSequenceTemplate(data: $data) { id name }
  }
`;

export const UPDATE_CRM_SEQUENCE_TEMPLATE = gql`
  mutation UpdateCrmSequenceTemplate($where: CrmSequenceTemplateWhereInput, $data: CrmSequenceTemplateDataInput) {
    updateCrmSequenceTemplate(where: $where, data: $data) { id }
  }
`;

const crmTemplates = { CREATE_CRM_SEQUENCE_TEMPLATE, UPDATE_CRM_SEQUENCE_TEMPLATE };
export default crmTemplates;
